'use client';
'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var tailwindMerge = require('tailwind-merge');
require('../../../_virtual/_tslib.js');
var Box = require('../../Base/Layouts/Box/Box.js');
require('../../Base/Layouts/FullBleed/FullBleed.js');
var BackDrop = require('../BackDrop/BackDrop.js');

const TRANSITION_DURATION = 'duration-300';
const BackDropLiftContainer = ({ isOpen, onClose, children, isBackgroundBlack = true, isPreventScroll = true, isBottomSheet = false, testId })=>{
    const [isAnimating, setIsAnimating] = react.useState(false);
    const [isRender, setIsRender] = react.useState(false);
    const handleTransitionEnd = ()=>{
        if (!isOpen) {
            setIsRender(false);
        }
    };
    react.useEffect(()=>{
        if (isOpen) {
            setIsRender(true);
            requestAnimationFrame(()=>setIsAnimating(true));
        } else {
            setIsAnimating(false);
        }
    }, [
        isOpen
    ]);
    if (!isRender && !isOpen) return null;
    return jsxRuntime.jsxs(Box, {
        className: tailwindMerge.twJoin('fixed inset-0 z-30 flex justify-center transition-opacity', TRANSITION_DURATION, isBottomSheet ? 'items-end' : 'items-center', isAnimating ? 'opacity-100' : 'opacity-0'),
        "data-testid": testId || 'design-system--backdrop-lift-container',
        children: [
            jsxRuntime.jsx(BackDrop, {
                onClick: onClose,
                isBlack: isBackgroundBlack,
                preventScroll: isPreventScroll
            }),
            jsxRuntime.jsx(Box, {
                className: tailwindMerge.twMerge('z-30 transition-all ease-in', TRANSITION_DURATION, isBottomSheet && 'w-full', isAnimating ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'),
                onTransitionEnd: handleTransitionEnd,
                children: children
            })
        ]
    });
};

module.exports = BackDropLiftContainer;
